import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import { IconText } from 'components/core/IconText/IconText';

import './ToastNotification.scss';

export function ToastNotification({
	text
}) {
	return (
		<CSSTransition
			classNames="transition-fade"
			timeout={4000}
			mountOnEnter
			unmountOnExit
			appear
			in
		>
			<div className="toast-notification-wrapper">
				<IconText
					type="dark"
					size="medium"
					centerText
					className="toast-notification"
					textClassName="toast-notification-text"
				>
					{text}
				</IconText>
			</div>
		</CSSTransition>
	);
}

ToastNotification.propTypes = {
	text: PropTypes.string.isRequired
};

export default ToastNotification;
